import { render, staticRenderFns } from "./CaratulaDelegaciones.vue?vue&type=template&id=173df1e3&scoped=true"
import script from "./CaratulaDelegaciones.vue?vue&type=script&lang=js"
export * from "./CaratulaDelegaciones.vue?vue&type=script&lang=js"
import style0 from "./CaratulaDelegaciones.vue?vue&type=style&index=0&id=173df1e3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173df1e3",
  null
  
)

export default component.exports